function gbAuto(v){var h=v.closest('[data-gb-autoplay]');return h&&h.dataset.gbAutoplay==='true';}
(function(){
  function activate(v){
    if(v.dataset.gbLoaded) { if(gbAuto(v)){v.muted=true;v.play().catch(function(){});} return; }
    v.dataset.gbLoaded='1'; v.preload='auto'; v.load();
    if(gbAuto(v)){ v.muted=true; v.play().catch(function(){}); }
  }
  function deactivate(v){ if(!v.paused) v.pause(); }
  function isActive(v){
    var w=v.closest('.shop-main-image, .shop-image-zoom-wrapper');
    return !w || w.classList.contains('active');
  }
  function scan(root){
    (root||document).querySelectorAll('video.shop-video').forEach(function(v){
      if(v.dataset.gbObserved) return; v.dataset.gbObserved='1';
      var io=new IntersectionObserver(function(es){
        es.forEach(function(e){
          if(e.isIntersecting && isActive(v)) activate(v); else deactivate(v);
        });
      },{rootMargin:'200px'});
      io.observe(v);
      var host=v.closest('.shop-main-image, .shop-image-zoom-wrapper');
      if(host){
        new MutationObserver(function(){
          if(host.classList.contains('active')){ var r=v.getBoundingClientRect(); if(r.bottom>0&&r.top<innerHeight+200) activate(v); }
          else deactivate(v);
        }).observe(host,{attributes:true,attributeFilter:['class']});
      }
    });
  }
  document.addEventListener('DOMContentLoaded',function(){scan();});
  document.addEventListener('shopify:section:load',function(e){scan(e.target);});
})();
